import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { API_URL } from '@/config';
import storage from '@/utils/storage';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = storage.getToken();
  const tokenReset = storage.getResetToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (tokenReset) {
    config.headers.Authorization = `Bearer ${tokenReset}`;
  }
  config.headers.Accept = 'application/json';
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
  timeout: 180000,
});

axios.interceptors.request.use(authRequestInterceptor);


axios.interceptors.response.use(
  (response) => {
    if (response?.data?.message === "Password reset successful") {
      setTimeout(() => {
        window.location.assign('/auth/login');
      }, 1000);
    }
    return response.data;
  },
  (error) => {
    console.log("error", error);
    const message = error.response?.data?.message || error.message;
    if (error?.response?.status === 401) {
      setTimeout(() => {
        storage.clearToken();
      
      }, 1000);
    }
    if (error?.response?.status === 500) {
      Swal.fire({
        icon: 'error',
        text: "🛠️ The server is rebooting its brain",
        color: '#fff',
        background: 'black',
      })
      return
    }

    Swal.fire({
      icon: 'error',
      text: message,
      color: '#fff',
      background: 'black',
    })
    console.log(message);
    return Promise.reject(error);
  }
);
